import { createFileRoute } from '@tanstack/react-router'

import { Profiles } from '@/widgets/case-management/profiles'

export const Route = createFileRoute('/_app/case-management/profiles/')({
  component: RouteComponent,
})

export const CaseManagementProfilesRoute = Route

function RouteComponent() {
  return <Profiles />
}
